import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetPlaceholderComponent } from '@app/components/widget-placeholder/widget-placeholder.component';
import { SafePipe } from '@app/pipes/safe.pipe';
import { LinkDirective } from '@app/directives/link.directive';
import { ErrorTemplatesComponent } from '@app/components/error-templates/error-templates.component';
import { AlertTemplatesComponent } from '@app/components/alert-templates/alert-templates.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';


@NgModule({
  declarations: [
    WidgetPlaceholderComponent,
    SafePipe,
    LinkDirective,
    AlertTemplatesComponent,
    ErrorTemplatesComponent,
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatSlideToggleModule
  ],
  exports: [
    WidgetPlaceholderComponent,
    SafePipe,
    LinkDirective,
    AlertTemplatesComponent,
    ErrorTemplatesComponent,
  ]
})
export class SharedModule { }
